var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "add" }, [
    _c(
      "div",
      {
        staticStyle: {
          "max-height": "70vh",
          "overflow-y": "auto",
          padding: "10px 15px",
        },
      },
      [
        _c(
          "el-form",
          {
            ref: "ruleForm",
            attrs: {
              model: _vm.ruleForm,
              rules: _vm.rules,
              size: "small",
              "label-position": "top",
            },
          },
          [
            _c(
              "el-row",
              { attrs: { gutter: 10 } },
              [
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("routes.班次编号"),
                          prop: "scheduleNumber",
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            maxlength: "100",
                            "show-word-limit": "",
                            placeholder: _vm.$t("GlobalSetObj.pleaseInput"),
                            disabled:
                              _vm.classId !== "" &&
                              _vm.classId !== null &&
                              _vm.classId !== undefined,
                          },
                          model: {
                            value: _vm.ruleForm.scheduleNumber,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "scheduleNumber", $$v)
                            },
                            expression: "ruleForm.scheduleNumber",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("GlobalSetObj.client") + "：",
                          prop: "customerIdList",
                          rules: {
                            required: true,
                            message: _vm.$t("GlobalSetObj.pleaseChoose"),
                            trigger: ["blur", "change"],
                          },
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticClass: "select",
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                              filterable: "",
                              clearable: "",
                              remote: "",
                              disabled:
                                _vm.classId !== "" &&
                                _vm.classId !== null &&
                                _vm.classId !== undefined,
                              "remote-method": _vm.asyncCustomerList,
                            },
                            on: {
                              "visible-change": function ($event) {
                                return _vm.asyncCustomerList()
                              },
                            },
                            model: {
                              value: _vm.ruleForm.customerIdList,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "customerIdList", $$v)
                              },
                              expression: "ruleForm.customerIdList",
                            },
                          },
                          _vm._l(_vm.customerList, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: {
                                label:
                                  item.customerAlias +
                                  (item.username
                                    ? "（" + item.username + "）"
                                    : ""),
                                value: item.id,
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("collectionCenter.transferCenter"),
                          prop: "transferCenterId",
                          rules: {
                            required: true,
                            message: _vm.$t("GlobalSetObj.pleaseChoose"),
                            trigger: ["blur", "change"],
                          },
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                              clearable: "",
                              filterable: "",
                              disabled:
                                _vm.classId !== "" &&
                                _vm.classId !== null &&
                                _vm.classId !== undefined,
                            },
                            model: {
                              value: _vm.ruleForm.transferCenterId,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "transferCenterId", $$v)
                              },
                              expression: "ruleForm.transferCenterId",
                            },
                          },
                          _vm._l(_vm.transferList, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.name, value: item.id },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._l(_vm.ruleForm.collectTimeList, function (item, ind) {
              return _c(
                "el-card",
                { key: ind },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 10 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { display: "inline-block" },
                              attrs: {
                                label: _vm.$t("collectionCenter.lanshouT"),
                                prop:
                                  "collectTimeList." +
                                  ind +
                                  ".startCollectTime",
                                rules: {
                                  required: true,
                                  validator: function (rule, value, callback) {
                                    return _vm.collectTimeCheck(
                                      rule,
                                      value,
                                      callback,
                                      item,
                                      _vm.ruleForm.collectTimeList,
                                      1
                                    )
                                  },
                                  trigger: ["blur", "change"],
                                },
                              },
                            },
                            [
                              _c("el-time-picker", {
                                staticStyle: { width: "180px" },
                                attrs: {
                                  placeholder: _vm.$t(
                                    "GlobalSetObj.pleaseChoose"
                                  ),
                                  format: "HH:mm",
                                  "value-format": "HH:mm",
                                },
                                model: {
                                  value: item.startCollectTime,
                                  callback: function ($$v) {
                                    _vm.$set(item, "startCollectTime", $$v)
                                  },
                                  expression: "item.startCollectTime",
                                },
                              }),
                            ],
                            1
                          ),
                          _c("span", { staticStyle: { margin: "0 5px" } }, [
                            _vm._v("~"),
                          ]),
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { display: "inline-block" },
                              attrs: {
                                prop:
                                  "collectTimeList." + ind + ".endCollectTime",
                                rules: {
                                  required: true,
                                  validator: function (rule, value, callback) {
                                    return _vm.collectTimeCheck(
                                      rule,
                                      value,
                                      callback,
                                      item,
                                      _vm.ruleForm.collectTimeList,
                                      2
                                    )
                                  },
                                  trigger: ["blur", "change"],
                                },
                              },
                            },
                            [
                              _c("el-time-picker", {
                                staticStyle: { width: "180px" },
                                attrs: {
                                  placeholder: _vm.$t(
                                    "GlobalSetObj.pleaseChoose"
                                  ),
                                  format: "HH:mm",
                                  "value-format": "HH:mm",
                                },
                                model: {
                                  value: item.endCollectTime,
                                  callback: function ($$v) {
                                    _vm.$set(item, "endCollectTime", $$v)
                                  },
                                  expression: "item.endCollectTime",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("GlobalSetObj.collectuploadTime"),
                                prop:
                                  "collectTimeList." +
                                  ind +
                                  ".collectLoadFinishTime",
                                rules: {
                                  required: true,
                                  validator: function (rule, value, callback) {
                                    return _vm.collectLoadFinishTimeCheck(
                                      rule,
                                      value,
                                      callback,
                                      item
                                    )
                                  },
                                  trigger: ["blur", "change"],
                                },
                              },
                            },
                            [
                              _c("el-time-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: _vm.$t(
                                    "GlobalSetObj.pleaseChoose"
                                  ),
                                  format: "HH:mm",
                                  "value-format": "HH:mm",
                                },
                                model: {
                                  value: item.collectLoadFinishTime,
                                  callback: function ($$v) {
                                    _vm.$set(item, "collectLoadFinishTime", $$v)
                                  },
                                  expression: "item.collectLoadFinishTime",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "collectionCenter.ArrivalTimeAtHUB"
                                ),
                                prop:
                                  "collectTimeList." + ind + ".hub1ArrivalTime",
                                rules: {
                                  required: true,
                                  validator: function (rule, value, callback) {
                                    return _vm.hub1ArrivalTimeCheck(
                                      rule,
                                      value,
                                      callback,
                                      item
                                    )
                                  },
                                  trigger: ["blur", "change"],
                                },
                              },
                            },
                            [
                              _c("el-time-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: _vm.$t(
                                    "GlobalSetObj.pleaseChoose"
                                  ),
                                  format: "HH:mm",
                                  "value-format": "HH:mm",
                                },
                                model: {
                                  value: item.hub1ArrivalTime,
                                  callback: function ($$v) {
                                    _vm.$set(item, "hub1ArrivalTime", $$v)
                                  },
                                  expression: "item.hub1ArrivalTime",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      ind !== 0
                        ? _c(
                            "el-col",
                            {
                              staticStyle: { "text-align": "right" },
                              attrs: { span: 2 },
                            },
                            [
                              _c(
                                "el-popconfirm",
                                {
                                  attrs: {
                                    title: _vm.$t(
                                      "GlobalSetObj.AreYouSureDelete"
                                    ),
                                  },
                                  on: {
                                    confirm: function ($event) {
                                      return _vm.delRow(ind)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        slot: "reference",
                                        type: "text",
                                        size: "small",
                                      },
                                      slot: "reference",
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-close",
                                        staticStyle: {
                                          "font-size": "25px",
                                          color: "#DD4A68",
                                        },
                                      }),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
          ],
          2
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticStyle: { padding: "10px", "text-align": "right" } },
      [
        _c(
          "el-button",
          {
            staticStyle: { float: "left" },
            attrs: { type: "primary", plain: "", size: "small" },
            on: { click: _vm.addRow },
          },
          [_vm._v(_vm._s(_vm.$t("collectionCenter.AddCollectionTime")))]
        ),
        _c(
          "el-button",
          {
            attrs: { type: "primary", size: "small" },
            on: {
              click: function ($event) {
                return _vm.submitForm("ruleForm")
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("customerManagements.Save")))]
        ),
        _c(
          "el-button",
          {
            attrs: { size: "small" },
            on: {
              click: function ($event) {
                return _vm.onClose(false)
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("GlobalSetObj.cancel")))]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }